"use strict";
// Copyright (c) 2021 by Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModule = exports.moduleProps = void 0;
const composition_api_1 = require("@vue/composition-api");
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.moduleProps = {
    containerIndex: {
        type: Number,
        required: true
    },
    controls: {
        type: Object,
        required: true
    },
    columns: {
        type: Number,
        required: true
    },
    definition: {
        type: Object,
        required: true
    },
    elementProps: {
        type: Object,
        required: false,
        default: () => ({})
    },
    index: {
        type: Number,
        required: true
    },
    modules: {
        type: Object,
        required: true
    },
    showControls: {
        type: Boolean,
        required: false,
        default: false
    }
};
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.useModule = (props, ctx) => {
    const isResizable = composition_api_1.computed(() => {
        var _a;
        return (_a = props.definition.size.isResizable) !== null && _a !== void 0 ? _a : true;
    });
    const decoration = composition_api_1.ref('');
    const gridTemplate = composition_api_1.computed(() => {
        const size = props.definition.size;
        return {
            gridColumn: size.colSpan > props.columns ? `span ${props.columns}` : `span ${size.colSpan}`,
            gridRow: `span ${size.rowSpan}`
        };
    });
    const resolvedModule = composition_api_1.computed(() => {
        if (!(props.definition.module in props.modules)) {
            throw new Error(`(Builder) There's no container data provided for [${props.definition.module}]`);
        }
        return props.modules[props.definition.module];
    });
    function clone() {
        ctx.emit('clone', props.definition, resolvedModule.value);
    }
    function resize(step, axis) {
        const definition = Object.assign({}, props.definition);
        switch (axis) {
            case 'x':
                definition.size.colSpan = definition.size.colSpan + step;
                if ((definition.size.colSpan < 0 || definition.size.colSpan > props.columns) ||
                    (definition.size.minColSpan && definition.size.colSpan < definition.size.minColSpan) ||
                    (definition.size.maxColSpan && definition.size.colSpan > definition.size.maxColSpan)) {
                    return;
                }
                break;
            case 'y':
                definition.size.rowSpan = definition.size.rowSpan + step;
                if (definition.size.rowSpan < 0 ||
                    (definition.size.minRowSpan && definition.size.rowSpan < definition.size.minRowSpan) ||
                    (definition.size.maxRowSpan && definition.size.rowSpan > definition.size.maxRowSpan)) {
                    return;
                }
        }
        ctx.emit('update:definition', definition);
    }
    function onDecorationChange(className) {
        decoration.value = className;
    }
    function triggerEvent(name) {
        ctx.emit(name, { type: name, module: props.definition.module, containerIndex: props.containerIndex, index: props.index });
    }
    return { clone, decoration, gridTemplate, isResizable, onDecorationChange, resize, resolvedModule, triggerEvent };
};
//# sourceMappingURL=Module.hooks.js.map